import {
  ShopFeatureEvent,
  TrackingCoreComponentTypes,
} from '../../../types/tracking-core-events-type';
import {WithOptionalTypes} from '../helpers/withOptionalTypes';

// Parameters accepted by the factory: all properties of a component event
// except the `event` field which will be set by the factory.
type TrackComponentParams = Omit<
  TrackingCoreComponentTypes,
  'event' | 'details' | 'abtest_flag' | 'event_scope' | 'object_details'
>;

type TrackComponentParamsPartial = WithOptionalTypes<
  TrackComponentParams,
  'sponsored' | 'page_type_id'
>;

export const trackComponent =
  (params: TrackComponentParamsPartial) =>
  (): ShopFeatureEvent<TrackingCoreComponentTypes> => {
    const event: ShopFeatureEvent<TrackingCoreComponentTypes> = {
      GA4: {
        ...params,
        event: 'component',
        abtest_flag: false,
        event_scope: 'long',
        context: params.context ?? '',
        object_context: '',
        page_type_id: params.page_type_id ?? '',
      },
    };

    return event;
  };
